import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <span className="font-heading text-[7rem] md:text-[12rem] font-black text-background-200 select-none leading-none">
        404
      </span>
      <h1 className="relative -mt-6 font-heading text-2xl md:text-4xl font-black text-foreground-950">
        这个页面还没上线
      </h1>
      <p className="mt-3 text-sm text-foreground-500 font-mono">{location.pathname}</p>
      <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-md leading-relaxed">
        你访问的地址可能已经调整。不妨回到专题合集总览，那里收录了全部上线中的合集与盘点。
      </p>
      <div className="mt-8 flex flex-col sm:flex-row items-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 h-12 px-7 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/topics"
          className="inline-flex items-center gap-2 h-12 px-7 rounded-md border border-background-300 text-foreground-800 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          浏览专题合集
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </div>
  );
}